import React from 'react';
import loadingIcon from '../../assets/icons/Loading_icon.gif'
export default function Loader() {
    return(
        <div className='loaderPage'>
            <img src={loadingIcon}  alt='loading'/>
        </div>
    )
}
